import { render, staticRenderFns } from "./GeneralInterest.vue?vue&type=template&id=2cec7f28"
import script from "./GeneralInterest.vue?vue&type=script&lang=js"
export * from "./GeneralInterest.vue?vue&type=script&lang=js"
import style0 from "./GeneralInterest.vue?vue&type=style&index=0&id=2cec7f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports